import { render, staticRenderFns } from "./GeographicalDistributions.vue?vue&type=template&id=2d4067d8&"
import script from "./GeographicalDistributions.vue?vue&type=script&lang=js&"
export * from "./GeographicalDistributions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports